<template>
    <div style="height: 100vh;display: flex;flex-flow: column;align-items: center;justify-content: center;">
        <!-- You might want to show a loading indicator here -->
        <img src="@/assets/img/logo.png" class="img-fluid pb-3" style="margin: auto auto 0; width: 90px;" alt="Logo">
        <span style="margin: 0 auto auto;">{{message}}</span>
    </div>
</template>
  
<script>
export default {
    name: 'SocialCallback',
    props: ['code', 'state', 'scope', 'error'],
    computed: {
        error() {
            return this.$store.getters.error;
        },
    },
    data() {
        return {
            message: 'Connexion en cours, merci de patienter...'
        }
    },
    mounted() {
        this.$store.dispatch('initState')
        if (this.code) {
            console.log("Token found:", this.token); // Check if token is logged
            setTimeout(() => { this.$store.dispatch('socialLogin', { code:this.code, state:this.state, scope:this.scope }) }, 3000);
        } else {
            // TODO: commit error to vuex storage and display it in login page
            this.$router.push('/login');
        }
    },
    watch: {
        '$store.state.error'(newValue) {
            // console.log('errors changed to:', newValue);
            if (newValue != '') {
                this.message = 'Erreur lors de la connexion. Veuillez réessayer.'
                setTimeout(() => { this.$router.push('/login') }, 3000);
            }
        }
    }
}
</script>